import React from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { isEmpty } from 'lodash';

export const TaskIdFilterSelector = ({ item, applyValue }) => {
  const handleOperatorChange = (event, newValue) => {
    applyValue({ ...item, value: !isEmpty(newValue) ? { operator: newValue, filterValue: null } : null });
  };
  const onFilterValueChange = event => {
    applyValue({ ...item, value: { ...item.value, filterValue: event.target.value } });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Autocomplete
        fullWidth
        options={['contains', 'is empty', 'is not empty']}
        value={item.value?.operator || null}
        onChange={handleOperatorChange}
        renderInput={params => (
          <TextField {...params} variant="standard" label={'Operator'} placeholder={'Operator'} fullWidth />
        )}
      />
      {item.value?.operator === 'contains' ? (
        <TextField
          value={item.value?.filterValue || ''}
          onChange={onFilterValueChange}
          variant="standard"
          label="Value"
          placeholder="Filter Value"
          fullWidth
        />
      ) : null}
    </Box>
  );
};
